export default {
  en: {
    'components.filing-types.title': 'Filing Types',
    'components.filing-types.no-results.title': 'No Filing Types',
    'components.filing-types.no-results.description':
      'No filings captured for this registration. Please add a filing to the registration to prepare filings.',
  },
};
